exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lista-cont[data-v-a2859468]{max-height:400px;overflow-y:auto}table[data-v-a2859468]{border-collapse:collapse;width:100%;font-size:34px;font-weight:400}table th[data-v-a2859468]{text-align:center;text-transform:uppercase}table td[data-v-a2859468],table td input[data-v-a2859468]{text-align:right}table td input[data-v-a2859468]{width:100%}table td[data-v-a2859468],table th[data-v-a2859468],table tr[data-v-a2859468]{border:1px solid rgba(0,0,0,.12);padding:7px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a2859468","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/pages/pcp/reporte.vue
// module id = 0r7Y
// module chunks = 0